import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'
import {Box, Card, Grid} from '@primer/react-brand'
import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'
import {renderWithoutParagraphs} from '../../../../utils'
import type {IntroSectionProps} from '../types'

type Props = Pick<IntroSectionProps, 'introImageCards'>

export function IntroImageCards({introImageCards}: Props) {
  if (!introImageCards || introImageCards.length === 0) return null

  return (
    <Box marginBlockStart={48}>
      <Grid>
        {introImageCards.map(card => (
          <Grid.Column key={card.sys.id} span={{xsmall: 12, medium: 6, large: 4}}>
            <Card href={card.fields.href} variant="minimal" fullWidth ctaText={card.fields.label}>
              <Card.Image
                src={`${card.fields.image.fields.file.url}?fm=webp`}
                alt={card.fields.image.fields.description || documentToPlainTextString(card.fields.heading) || ''}
                sources={getImageSources(card.fields.image.fields.file.url, {
                  maxWidth: MAX_CONTENT_WIDTH / 3,
                })}
              />
              <Card.Heading>
                {renderWithoutParagraphs(card.fields.heading)}
                {card.fields.alt ? <span className="sr-only"> {card.fields.alt}</span> : null}
              </Card.Heading>
              <Card.Description>{renderWithoutParagraphs(card.fields.description)}</Card.Description>
            </Card>
          </Grid.Column>
        ))}
      </Grid>
    </Box>
  )
}
